import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import QRCode from 'qrcode';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
  standalone: true,
})
export class QrCodeComponent implements OnChanges {
  @Input() alt: string;
  @Input() colorDark = '#000000ff';
  @Input() colorLight = '#ffffffff';
  @Input() cssClass = 'qrcode';
  @Input() elementType = 'svg';
  @Input() errorCorrectionLevel: 'L' | 'M' | 'Q' | 'H' = 'M';
  @Input() margin = 4;
  @Input() qrcode!: string; // required
  @Input() scale = 4;
  @Input() version: string;
  @Input() width = 200;

  qrCodeSvg: SafeHtml | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if ('qrcode' in changes && this.qrcode) {
      this.generateQrCode();
    }
  }

  private async generateQrCode(): Promise<void> {
    const rawSvg = await QRCode.toString(this.qrcode, {
      type: 'svg',
      width: this.width,
      errorCorrectionLevel: this.errorCorrectionLevel,
      color: {
        dark: this.colorDark,
        light: this.colorLight,
      },
      margin: this.margin,
    });

    // ✅ Mark as safe for Angular
    this.qrCodeSvg = this.sanitizer.bypassSecurityTrustHtml(rawSvg);
  }
}
